'use client';

import { useTranslations } from 'next-intl';
import type { FC } from 'react';
import { BaseLineInfo } from '@/app/components/icons/BaseLineInfo';
import { CustomTooltip } from '@/app/components/shared/CustomTooltip';
import { Button } from '@/app/components/ui/button';
import { useRouter } from '@/i18n/routing';

interface OfflineAvatarHistoryDetailButtonProps {
  creationId: string;
}

export const OfflineAvatarHistoryDetailButton: FC<OfflineAvatarHistoryDetailButtonProps> = ({ creationId }) => {
  const t = useTranslations();
  const router = useRouter();
  const label = t('creations.detail.title');

  return (
    <CustomTooltip content={label} trigger="hover">
      <Button
        variant="text"
        size="original"
        className="rounded-8 p-1.5 text-inherit text-xl hover:bg-system-hover01"
        aria-label={label}
        onClick={() => router.push(`/creation-detail/${creationId}`)}
      >
        <BaseLineInfo className="text-system-white" />
      </Button>
    </CustomTooltip>
  );
};
